export default "__VITE_ASSET__Dm36E0$Y__"